module.exports = __webpack_public_path__ + "img/cintillo.d42a242d.png";